import { MatDialog, MatTableDataSource, MatPaginator } from "@angular/material";
import { TranslateService } from "@ngstack/translate";
import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit, ViewChild } from "@angular/core";

import { LevelInfoService } from "src/app/services/http/business/levelInfo/level-info.service";
import { LevelInfoEntryComponent } from "../level-info-entry/level-info-entry.component";
import { ILevelInfo } from "src/app/interfaces/levelInfo";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { ErrorsService } from "src/app/services/common/errors.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";

@Component({
  selector: "app-level-info-list",
  templateUrl: "./level-info-list.component.html",
  styleUrls: ["./level-info-list.component.css"]
})
export class LevelInfoListComponent implements OnInit {
  isOwner: boolean;
  packageData: any = {
    PackageId: 0
  };
  pageSize: number;
  pageIndex: number;
  companySelected: string;
  dataSource = new MatTableDataSource<ILevelInfo>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private levelInfoService: LevelInfoService
  ) { }

  displayedColumns: string[] = [
    this.translate.get("label.levelCode"),
    this.translate.get("label.levelName"),
    this.translate.get("label.validatationDate"),
    this.translate.get("label.active"),
    this.translate.get("label.isGraduatedLevel"),
    this.translate.get("label.capacity"),
    "function"
  ];

  ngOnInit() {
    this.route.params.subscribe(res => {
      this.packageData.PackageId = res.packageId;
      let packageId = +res.packageId;
      this.getLevelInfoList(packageId);
    });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
    });
  }

  paginatorEvent(event) {
    this.levelInfoService
      .getList(this.packageData.PackageId, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  getLevelInfoList(id: number) {
    this.levelInfoService.getList(id, 1, 10).subscribe(res => {
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  add() {
    this.dialog
      .open(LevelInfoEntryComponent, {
        data: this.packageData
      })
      .afterClosed()
      .subscribe(() => {
        this.levelInfoService
          .getList(this.packageData.PackageId)
          .subscribe(re => {
            this.paginator.pageIndex = 0;
            this.dataSource = re.DataList;
            this.paginator.length = re.Total;
          });
      });
  }

  edit(e) {
    this.dialog
      .open(LevelInfoEntryComponent, {
        data: e
      })
      .afterClosed()
      .subscribe(() => {
        this.levelInfoService
          .getList(this.packageData.PackageId)
          .subscribe(re => {
            this.paginator.pageIndex = 0;
            this.dataSource = re.DataList;
            this.paginator.length = re.Total;
          });
      });
  }

  delete(data: ILevelInfo): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.level") + " " + data.Name
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var xdata = {
          id: data.Id
        };
        this.levelInfoService.delete(xdata).subscribe(
          () => {
            this.levelInfoService
              .getList(
                this.packageData.PackageId,
                this.pageIndex,
                this.pageSize
              )
              .subscribe(re => {
                this.dataSource = re.DataList;
                this.paginator.length = re.Total;
              });
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  ative(data: ILevelInfo): void {
    let confirm: IConfirm = {
      accept: true,
      message: data.IsActive
        ? this.translate.get("confirm.inActive", {
          name: this.translate.get("label.level") + " " + "'" + data.Name + "'"
        })
        : this.translate.get("confirm.active", {
          name: this.translate.get("label.level") + " " + "'" + data.Name + "'"
        }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var activate: any = {
        IsActive: !data.IsActive,
        Id: data.Id
      };
      if (result) {
        this.levelInfoService.active(activate).subscribe(
          () => {
            this.levelInfoService
              .getList(this.packageData.PackageId)
              .subscribe(re => {
                this.paginator.pageIndex = 0;
                this.dataSource = re.DataList;
                this.paginator.length = re.Total;
              });
          },
          () => {
            this.errorService.transactionError();
          }
        );
      }
    });
  }

  assignment(e) {
    this.router.navigate([]).then(() => { window.open("management/institute/levelprerequisite/" + e.PackageId + "/" + e.Id, '_blank'); });
  }
}
